/**
 * @file menu-items.js
 * @description Itens do menu principal da sidebar (CRA)
 */

import {
  Calendar,
  Circle,
  LayoutDashboardIcon,
  Home,
  MapPin,
  Package,
  Receipt,
  ShoppingCart,
} from "lucide-react"

/**
 * Itens do menu principal da sidebar
 */
export const MENU_ITEMS = [
  {
    icon: Home,
    label: "Dashboard",
    id: "dashboard",
    href: "/",
    description: "Visão geral do sistema",
    permission: "Dashboard",
    action: "islist",
  },
  {
    icon: LayoutDashboardIcon,
    label: "Dashboard SCP",
    id: "dashboard-scp",
    href: "/dashboard",
    description: "Dashboard SCP",
    permission: "Dashboard SCP",
    action: "isinsert",
  },
  {
    icon: Package,
    label: "Cliente",
    id: "cliente",
    href: "/clientes",
    description: "Gerenciar clientes",
    permission: "Cliente",
    action: "islist",
  },
  {
    icon: ShoppingCart,
    label: "Serviços",
    id: "servicos",
    href: "/listService",
    description: "Gerenciar serviços",
    permission: "Serviço",
    action: "islist",
  },
  {
    icon: MapPin,
    label: "Painel",
    id: "painel",
    href: "/listPanel",
    description: "Painel de controle",
    permission: "Painel",
    action: "islist",
  },
  {
    icon: Circle,
    label: "Circuito",
    id: "circuito",
    href: "/listCircuit",
    description: "Gerenciar circuitos",
    permission: "Circuito",
    action: "islist",
  },
  {
    icon: Calendar,
    label: "Orçamento",
    id: "orcamento",
    href: "/orcamento",
    hasIndicator: true,
    description: "Verificar orçamento",
  },
  {
    icon: Receipt,
    label: "Venda",
    id: "venda",
    href: "/vendas",
    hasIndicator: true,
    description: "Gerenciar vendas",
    permission: "Vendas",
    action: "islist",
  },
]
